// Timing constants
export const TIMING = {
  INIT_DELAY: 100,
  INIT_MESSAGE_DELAY: 150,
  INIT_COMPLETE_DELAY: 800,
  THINKING_MIN_DELAY: 800,
  THINKING_MAX_DELAY: 1500,
  THINKING_ANIMATION_DURATION: 2800,
  FOCUS_DELAY: 100,
  CLEAR_DELAY: 300,
} as const;

// Storage keys
export const STORAGE_KEYS = {
  INITIALIZED: 'mifta_initialized',
} as const;

// Limits
export const LIMITS = {
  MAX_CHAT_REQUESTS: 5,
} as const;

// API configuration
export const API_CONFIG = {
  ENDPOINT: import.meta.env.VITE_API_URL || 'https://api.mifta.dev/v1/chat',
  MODEL: 'google/gemini-2.0-flash-001',
  TIMEOUT: 10000,
} as const;

// System prompt
export const SYSTEM_PROMPT =
  'You are MIFTA AI assistant, a helpful automation expert. Keep responses concise and friendly. Help users with workflow automation, deployment, and development tasks.';
